import { BonusStage } from '@/api/common';

export const ACTIVE_BONUS_STAGES = [
  BonusStage.Issued,
  BonusStage.HandleBets,
  BonusStage.Activated,
];
